import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section id="about" className="AboutUs">
      <div className="AboutUs_Container">
        <div className="AboutUs_Content">
          <p>About Us</p>
          <h2>
            "Kivora is a studio based in Budapest.
            Born from a love of simplicity, nature, and the art of slow living, every piece is crafted by hand, 
            designed to bring warmth and beauty to your daily rituals.""
          </h2>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
